import type { Database } from "../../../../__definitions__/database-definitions";
import { SupabaseService } from "../../../../server/supabase/base-supabase-service";

export type SmsConfig = Database["public"]["Tables"]["sms_config"]["Row"];

export class SupabaseSmsConfigService extends SupabaseService<"sms_config"> {
  table = "sms_config" as const;
}
